import React, { useState } from 'react';
import ChangePassword from './ChangePassword';
import LoginForm from './LoginForm';
import './LoginPage.css';
import RegisterAccount from './RegisterAccount';
import RegistrationApproval from './RegistrationApproval';
import RegistrationPendingApproval from './RegistrationPendingApproval';

/* eslint-disable react/prop-types */

export type ComponentProps = {
  setActiveComponent: (key: string) => void;
};

type LoginProps = {
  loginComponent?: any;
};

type ComponentMap = {
  [key: string]: React.FC<{ setActiveComponent: (key: string) => void }>;
};

const componentMap: ComponentMap = {
  Login: ({ setActiveComponent }) => <LoginForm setActiveComponent={setActiveComponent} />,
  Register: ({ setActiveComponent }) => <RegisterAccount setActiveComponent={setActiveComponent} />,
  Approval: ({ setActiveComponent }) => <RegistrationApproval setActiveComponent={setActiveComponent} />,
  Pending: ({ setActiveComponent }) => <RegistrationPendingApproval setActiveComponent={setActiveComponent} />,
  Password: ({ setActiveComponent }) => <ChangePassword setActiveComponent={setActiveComponent} />,
};

const LoginPage: React.FC<LoginProps> = ({ loginComponent = 'Login' }) => {
  const [activeComponent, setActiveComponent] = useState(loginComponent); // Set the initial active component key

  return (
    <div className="flex flex-row w-100 mx-0 h-100 auth-page ">
      <div className="col-md-6 col-sm-6 col-lg-8 px-0 welcome-login">
        <div className="auth-side-wrapper">
          <div className="logo-welcome pt-4">
            Welcome to
            <br />
            <img className="logo-image" src="/assets/icons/spotlock/spotlock-logo-wtext.png" alt="" />
          </div>
        </div>
      </div>
      <div className="col-sm-6 col-md-6 col-lg-4 w-full">
        {React.createElement(componentMap[activeComponent], {
          setActiveComponent,
        })}
      </div>
    </div>
  );
};
export default LoginPage;
